import React from 'react';
import { Grid } from '@mui/material';
import Banner from '../../components/services/Banner';
import { Helmet } from 'react-helmet';
import HvacService from '../../components/services/hvac'


const HVAC = () => {

    const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [{
    "@type": "Question",
    "name": "What makes Unique Engineers one of the top HVAC companies in India?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Our custom-engineered systems, in-house teams, and deep cross-industry expertise distinguish us in the HVAC landscape."
    }
  },{
    "@type": "Question",
    "name": "Do you offer services beyond HVAC installations?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, we also provide full MEPF services, including fire protection, electrical systems and plumbing."
    }
  },{
    "@type": "Question",
    "name": "Are your HVAC solutions suitable for industrial use?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Absolutely. We specialise as industrial HVAC contractors in India, with clients in pharma, manufacturing, IT and food sectors."
    }
  },{
    "@type": "Question",
    "name": "Can you handle projects outside major metro cities?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes. Our teams execute projects across Tier 1, 2 and even remote locations across India."
    }
  },{
    "@type": "Question",
    "name": "What post-installation support do you provide?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "We offer comprehensive AMC packages, performance audits and periodic servicing by trained HVAC technicians."
    }
  }]

    };

    return (
        <Grid container style={{width:'100%', justifyContent:'center'}}>
<Helmet>
<title>HVAC Company in India | Industrial HVAC Contractors – Unique Engineers</title>
<meta name="description" content="Unique Engineers is a top HVAC company in India and trusted HVAC contractor, delivering industrial and commercial solutions among the best HVAC companies in India." />
<link rel="canonical" href="https://www.uniqueengineersltd.com/services/hvac-company-in-india/" />      

     <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
     </script>

</Helmet>
            <Banner img={'/assets/images/hvac-banner.jpg'} title= 'React out and Connect' />
            <HvacService />
        </Grid>
    )

}

export default HVAC;